import { Pipe, PipeTransform } from "@angular/core";
import { ConfigService } from "../services/config/config.service";

/**
 * Resolves UI asset paths with APPLICATION_BASE_PATH.
 * Usage: `'images/virtusa-icons/close.svg' | assetUrl`
 */
@Pipe({
  name: "assetUrl",
  standalone: true,
})
export class AssetUrlPipe implements PipeTransform {
  constructor(private readonly configService: ConfigService) {}

  transform(assetPath: string | null | undefined): string {
    return this.configService.buildAssetUrl(assetPath);
  }
}
